import { ConfiguratorGroupDto } from '@/services/configurator';
import { TaskStatus } from '@/types';
import { isGroupSigned } from './isGroupSigned';

/**
 * Derive a master-era TaskStatus from a v2 group so the existing Redux filter
 * shape (`statuses: TaskStatus[]`) keeps working. 'Reviewed' is not surfaced by
 * v2 — see `legacy/plan.md` "Deferred" notes.
 */
export function getGroupStatus(group: ConfiguratorGroupDto, isShowroom = false): TaskStatus {
    if (isGroupSigned(group, isShowroom)) return 'Sent';
    if (group.selectedOption) return 'Selected';
    return 'Default';
}
